import { render } from "./_form.vue?vue&type=template&id=1420ad17"
import script from "./_form.vue?vue&type=script&lang=js"
export * from "./_form.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/assets/_form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1420ad17"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1420ad17', __exports__)) {
    console.log('reload')
    api.reload('1420ad17', __exports__)
  }
  
  module.hot.accept("./_form.vue?vue&type=template&id=1420ad17", () => {
    console.log('re-render')
    api.rerender('1420ad17', render)
  })

}


export default __exports__